<template>
  <div 
    v-if="isLoading" 
    class="d-flex justify-center align-center" 
    style="width: 100%; height: 210px"
  >
    <v-progress-linear
      indeterminate
      style="width: 15%"
      rounded
    />
  </div>
  <v-slide-group
    class="pt-2 pb-3"
    v-else-if="!isEmpty"
    style="height: 214px"
  >
    <v-slide-item 
      v-for="item in this.items" 
      :key="item.id"
    >
      <div class="px-2 py-1">
        <CarouselCard 
          :item="item" 
          :on-click="onClick"
          :generic-image="genericImage"
        />
      </div>
    </v-slide-item>
  </v-slide-group>
  <div 
    v-else 
    class="d-flex fill-height justify-center align-center px-1" 
    style="width: 100%; height: 210px"
  >
    <v-card style="width:90%; background: rgba(255, 255, 255, 0.15)">
      <div style="height:120px" />
      <div 
        class="px-3 d-flex flex-row align-center" 
        style="height: 65px; background: #fff"
      >
        <v-icon color="primary">
          mdi-information-outline    
        </v-icon>
        <v-card-title class="ml-1 flex-grow-1">
          {{ noItemsMessage }}
        </v-card-title>
        <v-btn 
          icon 
          small 
          @click="loadItems()"
        >
          <v-icon color="primary">
            mdi-refresh
          </v-icon>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>

import { VCard, VSlideGroup, VSlideItem,  } from "vuetify/lib/components";
import CarouselCard from "../components/CarouselCard.vue";
import { mapGetters } from "vuex";

export default {
  name: 'GenericCarousel',
  components: {
    VCard, 
    VSlideGroup, 
    VSlideItem,
    CarouselCard
  },
  computed: {
    ...mapGetters(['schoolsLogo']),
    isEmpty() {
      return this.items.length === 0;
    },
  },
  data: () => ({
    move: [],
    drag: false,
    touch: false,
  }),
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isLoadingError: {
      type: Boolean,
      default: false
    },
    noItemsMessage: {
      type: String,
      default: 'No items available at this time'
    },
    loadItems: {
      type: Function,
      default: function() {
        return false
      }
    },
    onClick: {
      type: Function,
      default: function() {
        return false
      }
    },
    genericImage: {
      type: String,
      default: '/img/generic-news.svg'
    },
  }
}
</script>
<style lang="scss" scoped>
  .v-card__title {
    word-break: break-word;
    font-size: 1rem;
    line-height: 1.1rem;
    padding: 2px 8px;
    flex-grow: 1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .v-slide-group::v-deep .v-slide-group__content {
    padding-left: 16px;
    padding-right: 16px;
  }
</style>